/**
 * Social - Twitter - Share
 */
import React from 'react'
import twitterLogo from '../../../_images/logos/logo-black-twitter.png'
import '../../../_scss/components/social-icons.scss'

export type TwitterShareProps = {
  status: string
  url: string
}

// eslint-disable-next-line import/prefer-default-export
export const TwitterShare = ({ status, url }: TwitterShareProps) => {
  const path = 'https://twitter.com/intent/tweet?'

  return (
    <a href={`${path}url=${url}&status=${status}+${url}`} target="twitter">
     <i ><img className='share-twitter' src={twitterLogo} alt="twitter-logo"/></i>
   </a>
  )
}
